import styled from 'styled-components';
import Paper from 'components/Paper/paper';
import TableBootstrap from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  CampaignStatusProps,
  CampaignTableLineProps,
} from 'models/campaign-mkt';

export const ContainerTable = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const Line = styled.tr<CampaignTableLineProps>`
  line-height: 60px;
  ${({ emptyLine }) =>
    emptyLine &&
    `
    height: 100%;
    line-height: 0px;
  `}
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
`;

export const StatusStyled = styled.span<CampaignStatusProps>`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 14px;
  text-align: center;
  letter-spacing: -0.6px;
  color: ${({ finish }) => (finish ? '#77C824' : '#4a90e2')};
`;

export const Tbody = styled(Paper).attrs({
  as: 'tbody',
})``;

export const Table = styled(TableBootstrap)`
  width: 100%;
  margin-bottom: 0px;
  color: #6c757d;
  font-size: 13px;
  line-height: 14px;
  font-weight: 300;
  min-width: 1200px;

  td {
    text-align: center;
    padding: 0px;
    vertical-align: middle;
  }

  tbody tr td:first-child,
  thead tr td:first-child {
    text-align: left;
    padding-left: 23px;
    font-weight: 500;
  }
  thead td {
    font-family: 'Gotham';
    font-weight: 500;
    font-size: 13px;
    color: #343a40;
  }
`;

export const NoResultsFoundStyled = styled.td`
  font-family: 'Roboto Flex', sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  text-align: center !important;
  letter-spacing: -0.6px;
  color: #d7dce3;
  vertical-align: middle;
`;
